<template>
  <AlertIf18 v-if="isTimeoutFinished" />
  <TheHeader v-if="this.$route.name !== 'PageNotFound'" />
  <div class="w-100 h-100 d-flex flex-column align-items-stretch justify-content-c">
    <router-view v-slot="slotProps">
      <component :is="slotProps.Component"></component>
    </router-view>
    <TheFooter v-if="this.$route.name !== 'PageNotFound'" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AlertIf18 from "./components/Global/AlertIf18.vue";
import TheHeader from "./components/Global/TheHeader.vue";
import TheFooter from "./components/Global/TheFooter.vue";
export default {
  name: "App",
  components: {
    AlertIf18,
    TheHeader,
    TheFooter,
  },

  data() {
    return {
      baseImg: process.env.VUE_APP_PUBLIC_PATH,
      lang: localStorage.getItem("language") ?? "en",
      loadingComplete: false,
      isTimeoutFinished: false,
    };
  },
  computed: {
    ...mapGetters("casinoGames", ["games", "isLoadingCardGames"]),
  },
  mounted() {
    this.timeoutFinished();
  },
  created() {
    document.body.style.fontFamily = "Poppins, sans-serif";
    document.body.style.maxWidth = "100%";
    document.body.style.margin = "0 auto";
    this.$store.dispatch("api/createAuth");
  },
  methods: {
    timeoutFinished() {
      setTimeout(() => {
        this.isTimeoutFinished = true;
      }, 1500);
    },
  },
};
</script>

<style>
body {
  box-sizing: border-box;
}
.color-full {
  background: #1d1028 !important;
  width: 100%;
  position: fixed;
  z-index: 200;
}

/* VUE TRANSITION - START*/
.route-enter {
  opacity: 0;
  transform: translateY(-20px);
}

.route-enter-active {
  transition: all 0.5s ease-in-out;
}

.route-leave-active {
  transition: all 0.5s ease-in-out;
}

.route-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.route-leave {
  opacity: 1;
  transform: translateY(0px);
}

.route-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

</style>
